'use strict';

const _ = require('lodash');

const SelectOrganizationFormController = function (sbAuth, IdentityService, IntercomService, ManagerStore, OrganizationStore, PlanStore, RoutingUtil) {

  const vm = this;
  vm.user = IdentityService.get('user');
  const storedOrg = IdentityService.get('currentOrganization');
  const currentOrg = _.isEmpty(storedOrg) ? vm.user.organizations[0] : storedOrg;
  vm.selectedOrg = currentOrg;
  vm.currentOrgId = currentOrg.id.toString();
  vm.buttonText = 'Continue';
  vm.menuActive = false;
  vm.authed = true;

  const onAuthSuccess = (payload) => {

    PlanStore.clearStore();
    OrganizationStore.clearStore();
    ManagerStore.clearStore();
    const res = payload.data;
    Object.keys(res).forEach((key) => {
      // Don't reset the user object
      // vm doesn't need to happen because it doesn't change
      // And it is removing properties set by the loginController
      // In particular, the adminLoginController
      if (res[key] !== 'user') {
        IdentityService.set(key, res[key]);
      }
    });
    IdentityService.set('currentOrganization', vm.selectedOrg);

    IntercomService.update({ 'Core_Last_Organization_Name': vm.selectedOrg.name }); // records vm in intercom
    IntercomService.update({ 'Core_Last_Organization_Id': vm.selectedOrg.id }); // records vm in intercom

    RoutingUtil.redirectTo('dash.map');
  };

  const onAuthError = () => {

    vm.buttonText = 'Continue';
  };

  vm.proceedToDashboard = () => {

    vm.buttonText = 'Loading...';
    vm.selectedOrg = vm.user.organizations.find((org) => {

      return org.id == vm.currentOrgId;
    });
    IdentityService.set('lastVisitedSiteSlug', null);

    const data = {
      email: vm.user.email,
      organization: vm.selectedOrg
    };
    sbAuth.setOrganization(data, onAuthSuccess, onAuthError);
  };

  vm.openChat = () => {

    IntercomService.show();
  };

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

module.exports = SelectOrganizationFormController;



// WEBPACK FOOTER //
// ./src/app/login/selectOrganization/SelectOrganizationFormController.js